__turbopack_context__.v({
  "activeHighlight": "AppSection-module__za3yna__activeHighlight",
  "contentWrapper": "AppSection-module__za3yna__contentWrapper",
  "heading": "AppSection-module__za3yna__heading" + " " + __turbopack_context__.i(515534)["sectionHeading"],
  "label": "AppSection-module__za3yna__label",
  "metricItem": "AppSection-module__za3yna__metricItem",
  "metricsBar": "AppSection-module__za3yna__metricsBar",
  "phoneImage": "AppSection-module__za3yna__phoneImage",
  "phoneScreen": "AppSection-module__za3yna__phoneScreen",
  "phoneWrapper": "AppSection-module__za3yna__phoneWrapper",
  "pulseRing": "AppSection-module__za3yna__pulseRing",
  "pulseRings": "AppSection-module__za3yna__pulseRings",
  "ring": "AppSection-module__za3yna__ring",
  "section": "AppSection-module__za3yna__section",
  "textBlock": "AppSection-module__za3yna__textBlock" + " " + __turbopack_context__.i(515534)["sectionTextBlock"],
  "videoLayer": "AppSection-module__za3yna__videoLayer",
});
